import { Document, Page } from 'react-pdf';
import 'react-pdf/dist/Page/TextLayer.css'; 
import 'react-pdf/dist/Page/AnnotationLayer.css';
import React, { useState } from 'react'; 
import { useMediaQuery } from 'react-responsive';
// import ContractPDF from '../utils/PDFGen/ContractPDF.jsx'; 
import ContractModal from './ContractModal.jsx';
import PreviewSVG from '../assets/Preview.jsx';
import { useFormContext } from "../utils/FormContext.jsx"
import config from '../utils/config.js';

// import DocumentSVG from '../assets/Document.jsx';

const PDFPreview = ({ formData }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [numPages, setNumPages] = useState(null);
    const { propertyData } = useFormContext(); 
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

    const onDocumentLoadSuccess = ({ numPages }) => {
      setNumPages(numPages);
    };
  
    const openModal = async () => {
      setIsModalOpen(true);
        const response = await fetch(`${config.apiBaseUrl}/fill-pdf`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({formData, propertyData}), // Send the form data as the body
      });
  
      if (response.ok) {
        // Get the filled PDF as a Blob
        const pdfBlob = await response.blob();
  
        // Create a Blob URL for the PDF
        const pdfUrl = URL.createObjectURL(pdfBlob);
  
        // Set the Blob URL in the state
        setPdfUrl(pdfUrl);
      } else {
        console.error('Error:', response.statusText);
      }
    };
  
    const closeModal = () => {
      setIsModalOpen(false);
    };

    // ORIGINAL RETURN METHOD TO RETURN PDF FROM S3
    // return (
    //     <div>

    //     {/* <DocumentSVG /> */}
    //     <button 
    //         onClick={openModal}
    //         className='text-shi-green px-2 py-[3px] text-sm rounded-md font-light font-inter hover:bg-slate-200 hover:text-shi-deep-purple'
    //         >Preview</button>
  
        
    //     {isModalOpen && (
    //         <ContractModal isOpen={isModalOpen} onClose={closeModal}>
    //             <ContractPDF />
    //         </ContractModal>
    //     )}
    //   </div>
    // );

    // NEW RETURN METHOD TO RETURN PDF FROM ANVIL
    return (
        <div>
          {/* <DocumentSVG /> */}
          <button 
            onClick={openModal}
            className='text-shi-green h-[30px] px-2 md:py-[3px] text-[14px] md:text-sm rounded-md font-light font-inter hover:bg-slate-200 hover:text-shi-deep-purple border border-slate-700 flex items-center'
          >
            {isMobile ? <PreviewSVG width={23} height={20} /> : 'Preview'}
          </button>
    
          {isModalOpen && (
            <ContractModal isOpen={isModalOpen} onClose={closeModal}>
              {pdfUrl && (
                <Document file={pdfUrl} onLoadSuccess={onDocumentLoadSuccess}>
                    {Array.from(new Array(numPages), (el, index) => (
                        <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                    ))}
                </Document>
              )}
            </ContractModal>
          )}
        </div>
      );
  };
  
  export default PDFPreview;